import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("i", {
    class: _normalizeClass(`icon mdi mdi-${_ctx.icon}`),
    style: _normalizeStyle(`font-size:${_ctx.size};`)
  }, null, 6);
}